import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { getData } from 'src/services/RestApi';
import SearchSelectField from 'src/components/widgets/search-select-field';
import {
  setCacheLegalPlates,
  getCacheLegalPlates,
} from 'src/utils/cache-data';

export const DropdownLegalPlates = ({ formik, hintValue, disabled = false, onlyRow = false, onCallback }) => {
  const [plates, setPlates] = useState([]);
  const [label, setLabel] = useState('');
  const isFetchingData = useRef(false); // Ref to track if the API call is in progress

  // Memoize the API call function to avoid calls many more
  const fetchData = useCallback(async () => {
    if (!isFetchingData.current && plates.length === 0) {
      isFetchingData.current = true; // Set the flag to avoid API calls
      const { result } = await getData('fixed/cars/legal/cache');
      if (result) {
        const platesResult = [];
        result.map((element) => {
          const carId = `${element.value}`;
          platesResult.push({ label: element.label, value: carId });
        });

        // Set cache plates
        setPlates(platesResult); // Store data in state
        setCacheLegalPlates(platesResult);
      }
      isFetchingData.current = false; // Reset the flag after fetching
    }
  }, [plates]);

  useEffect(() => {
    if(!onlyRow){
      const savedData = getCacheLegalPlates();
      if (Array.isArray(savedData)) {
       setPlates(savedData);
     } else {
        fetchData(); // Fetch data on component mount
     }
    }
    if(hintValue){
      setLabel(hintValue);
    }
  }, []);

  const handleChanged = (selectedOption) => {
    formik.setFieldValue('plateField', selectedOption);
    if(onCallback){
      onCallback(selectedOption.value);
    }
  };

  return (
    <SearchSelectField
      label="Biển số"
      name="plateField"
      disabled={disabled}
      options={plates}
      onSelected={handleChanged}
      formik={formik}
      hintValue={label} //'59A-12345'
      onlyRow={onlyRow}
    />
  );
};

DropdownLegalPlates.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default DropdownLegalPlates;
